import { FlexProps } from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';
import React from 'react';

type FilterBarContainerProps = {
  children: React.ReactNode;
};

export const FilterBarContainer: React.FC<
  FilterBarContainerProps & FlexProps
> = ({ children, ...props }) => {
  return (
    <Flex
      px={4}
      direction="row"
      alignItems={'center'}
      justifyContent="flex-between"
      zIndex="1"
      borderWidth="1px"
      borderColor="surface.border"
      borderRadius="lg"
      position="relative"
      {...props}>
      {children}
    </Flex>
  );
};
